import React from 'react';
import PropTypes from 'prop-types';
import Badge from 'components/v2/Badge';
import LocationSearch from 'components/site/location-search';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

export default function OriginDsestinationSearch({
  filterGroup,
  filterMetadata,
  onFilterChange,
}) {
  const { t } = useTranslation();
  function renderSelected(label, filterGroup) {
    return (
      <div key={label} className="mb-2">
        <Badge
          color="green"
          withRemove
          onRemove={() => onFilterChange(filterGroup, { address: '' }, false)}
        >
          {label}
        </Badge>
      </div>
    );
  }
  const { key } = filterGroup;
  return filterMetadata[key]?.address ? (
    renderSelected(filterMetadata[key]?.address, filterGroup)
  ) : (
    <LocationSearch
      placeholder={titleize(t(filterGroup.name.toUpperCase()))}
      handleLocationSearch={(item) => {
        onFilterChange(filterGroup, item, true);
      }}
    />
  );
}

OriginDsestinationSearch.propTypes = {
  filterMetadata: PropTypes.object,
  filterGroup: PropTypes.object,
  onFilterChange: PropTypes.func,
};

OriginDsestinationSearch.defaultProps = {
  filterMetadata: {},
  filterGroup: {},
  onFilterChange: () => {},
};
